import React from 'react';
import '../App.css';
import '../style.css';
import { Link } from 'react-router-dom';
import {useState} from 'react';
import { Thumbnail } from './WorkThumbnail';
import { ArticleMainImage } from '../articleDetailPage/ArticleMainImage';
import { useLanguage } from '../contexts/LanguageContext';


export function BlogContent (props: {
    thumbnail?: string;
    title: string;
    description : string;
    category : string;
    date : string;
    blogPage : string;
    locked : boolean;
    /** 영문 토글 시 노출되는 텍스트. 없으면 한국어 원문을 그대로 보여줌. */
    titleEn?: string;
    descriptionEn?: string;
    categoryEn?: string;
    /** PageActivities: 공개일 기준 28일 이내일 때 true로 전달 */
    showNewBadge?: boolean;
}) {
    const [isHovering, setIsHovering] = useState(false);
    const { language } = useLanguage();
    const isEn = language === 'en';
    const displayTitle = isEn && props.titleEn ? props.titleEn : props.title;
    const displayDescription = isEn && props.descriptionEn ? props.descriptionEn : props.description;
    const displayCategory = isEn && props.categoryEn ? props.categoryEn : props.category;

  return (
    <div className='projectContentsAll' onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
        <Link to={props.blogPage} className='project' style={{textDecoration: 'none'}} >
        <div className='blogContents'>
            <div style={{display : "flex", flexDirection : "row", justifyContent: "space-between", alignItems:"flex-start", width: "100%"}}>
                <div style={{display : "flex", flexDirection : "column",gap:"20px", flex: 1, marginRight: "24px"}}>
                    <div className='projectSubtitle'>
                        {displayCategory}
                    </div>
                    <div style={{display : "flex", flexDirection : "column",gap:"10px"}}>
                        <div style={{display : "flex", flexDirection : "row", gap:"8px", alignItems:"center", marginTop: "0px", flexWrap: "wrap"}}>
                        <div className="projectTitle">
                            {displayTitle}
                        </div>
                        {(props.showNewBadge || props.locked) && (
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                            {props.showNewBadge && (
                            <div className="projectNewBadge projectNewBadgeInline"><span className="projectNewBadgeText">New</span></div>
                            )}
                            {props.locked && (
                            <div className='projectLocked'>
                                <div className='projectLockedText'>Private</div>
                            </div>
                            )}
                        </div>
                        )}
                        </div>
                        <div className='projectDescription'>
                            {displayDescription}
                        </div>
                        <div className='projectPeriod'>{props.date}</div>
                    </div>
                </div>
                {props.thumbnail && (
                    <div style={{width: "240px", aspectRatio: "100/66", borderRadius:"15px", overflow:"hidden", flexShrink: 0, background: 'linear-gradient(var(--color-bg-soft) 0%, var(--color-bg-mid) 100%)' }}>
                        <img className="projectThumbnail" src={props.thumbnail} style={{width: "100%", height: "100%", objectFit: "cover"}} />
                    </div>
                )}
            </div>
        </div>
        </Link>
    </div>
  
  );
}

export default BlogContent;